declare global {
  interface Window {
    gtag: Function;
  }
}

export const updateGoogleConsent = ({
  analytics,
  marketing,
}: {
  analytics: boolean;
  marketing: boolean;
}) => {
  if (!window.gtag) return;

  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
};